/**
 * @description Link 資料應用的位置 (enum)
 */
export enum LinkPositionEnum {
  /** Header */
  Header = 'header',
  /** Footer */
  Footer = 'footer',
  /** Extra Doc */
  ExtraDoc = 'extdoc'
}
